import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import {deviceMax} from '../../theme/breakpoints'
import Image from '../Image/Image'
import Heading from '../Heading/Heading'
import ArrowRight from '../../images/icons/arrow-right-tile.svg'
import Button from "../Button/Button";

export const StyledCard = styled.div`
  position: relative;
  flex-direction: column;
  display: flex;
  margin: ${pxToRem(10)} ${pxToRem(10)};
  border-radius: ${pxToRem(5)};
  width: ${pxToRem(384)};
  max-height: ${pxToRem(450)};
  padding: ${pxToRem(10)};
  background-color: ${({theme}) => theme.colors.unique.white};
  text-decoration: inherit;
  @media ${deviceMax.mobileL} {
    margin: 0 0 ${pxToRem(20)};
    width: 100%;
    max-width: 100%;
    max-height: ${pxToRem(363)};
  }
  @media ${deviceMax.mobileS} {
    border-radius: 0;
  }
`
export const StyledDate = styled.p`
  color: ${({theme}) => theme.colors.opacity.black70};
  font-weight: ${({theme}) => theme.fonts.weight.normal};
  opacity: 70%;

  margin-bottom: ${pxToRem(10)};
`

export const StyleImageContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  margin-bottom: ${pxToRem(10)};
  height: ${pxToRem(160)};
`

export const StyledImage = styled(Image)`
  object-fit: cover;
  border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)} ${pxToRem(5)};
  height: ${pxToRem(160)};
`

export const StyleHeading = styled(Heading)`
  display: -webkit-box;
  height: 100%;
  max-height: ${pxToRem(47)};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  margin-bottom: ${pxToRem(10)};
  text-overflow: ellipsis;
`

export const StyledPlaceholder = styled.div`
  border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)} ${pxToRem(5)};
  margin-bottom: ${pxToRem(10)};
  height: ${pxToRem(160)};
  background-color: ${(props) =>
          props.color || props.theme.colors.unique.white};
`

export const StyledParagraph = styled.p`
  display: -webkit-box;
  overflow: hidden;
  margin-bottom: ${pxToRem(10)};
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: ${({theme}) => theme.fonts.sizes.base};
  font-weight: ${({theme}) => theme.fonts.weight.medium};
  line-height: ${({theme}) => theme.fonts.lineHeight.button};
  color: rgba(0, 0, 0, 0.7);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`

export const StyledLabel = styled.span`
  margin-right: ${pxToRem(10)};
`

export const StyleIcon = styled(ArrowRight)`
  width: ${pxToRem(24)};
  height: ${pxToRem(23)};
  padding: ${pxToRem(3)} ${pxToRem(3)};
  border: ${pxToRem(1)} solid ${({theme}) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
  vertical-align: middle;
`

export const StyledBodyCard = styled.div`
  flex-direction: column;
  flex-grow: 1;
  display: flex;
`

export const StyledButton = styled(Button)`
  height: ${pxToRem(50)};
`
